import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisApiService } from 'src/services/contentAnalysisApi'
import { ContentAnalysisSummaryListResponse } from 'src/services/contentAnalysisApi/interfaces/contentAnalysisSummary.interface'

interface UseGetContentAnalysisSummaryQueryParams {
  id: string
}

// Every stored summary of the analysis (the widget's tabs) plus the limit
// state. Not tied to the page date filter.
export const useGetContentAnalysisSummaryQuery = ({
  id,
}: UseGetContentAnalysisSummaryQueryParams) => {
  return useQuery({
    enabled: !!id,
    queryFn: () =>
      ContentAnalysisApiService.getSummaries<ContentAnalysisSummaryListResponse>(
        id
      ),
    queryKey: [QueryKey.GET_CONTENT_ANALYSIS_SUMMARY, id],
  })
}
